exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".equity-bar-element {\n    margin-right: 20px;\n    font-size: 0.6em;\n}\n\n.mat-toolbar {\n    background-color: rgba(18, 28, 37, 0.88);\n    height: 48px;\n    /* font-weight: 300; */\n    color: white;\n    border-top: 1px solid black;\n    border-bottom: 1px solid black;\n}\n\n.loss, .gain {\n    margin-left: 5px;\n    padding-left: 5px;\n    padding-right: 5px;\n}\n\n.loss {\n    border: 1px solid rgba(255,0,0,0.1);\n}\n\n.gain {\n    border: 1px solid rgba(0,255,0,0.1);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/thibautjacob/Documents/Projects/Portfolio/src/app/components/equities-bar/equities-bar.component.css
// module id = ../../../../../src/app/components/equities-bar/equities-bar.component.css
// module chunks = main